import React, { Fragment, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Chapter } from '@/app/models/new-resource'
import { ResourcesService } from '@/app/services/ResourcesService'
import { LuxTextInput, LuxRichInputText, LuxButton } from '@lux/wardrobe-lib'
import SectionItem from '@components/Layout/SectionItem/SectionItem'
import AddAttachment from '@components/UI/AddAttachment/AddAttachment'
import SectionItemContainer from '@/app/components/Layout/SectionItemContainer/SectionItemContainer'
import './ArticleChapter.scss'

const ArticleChapter = (props: {
    index: number
    chapter: Chapter
    disabled: boolean
    onSaveChapter: (whichChapter: Chapter) => void
    onReduceChapter: () => void
}) => {
    const { index, chapter, disabled, onSaveChapter, onReduceChapter } = props

    const intl = useIntl()

    const componentClass = 'smart-modals-new-resource-article-chapter'

    const [text, setText] = useState(chapter.text)
    const [title, setTitle] = useState(chapter.title)

    const [disabledSave, setDisabledSave] = useState<boolean>(true)

    useEffect(() => {
        setDisabledSave(true)
        if (/*stripTagsFroala(text) !== '' &&*/ title !== '') {
            setDisabledSave(false)
        }
    }, [text, title])

    /*
    const stripTagsFroala = (str: string) => {
        let stripTags = str?.replace(/(<([^>]+)>)/gi, '')
        let stripFroala = stripTags?.replace('Powered by Froala Editor', '')
        return stripFroala
    }
    */

    const onUploadAttachment = (files: any) => {
        onSaveChapter({
            ...chapter,
            attachments: [
                ...chapter.attachments,
                ...files.map((file: any) => ({
                    _id: file.id,
                    url: file.url,
                    file: file.file,
                    name: file.file.name,
                    ext: file.file.name?.split('.').pop() || file.file.type,
                }))
            ],
        })
    }

    const onRemoveAttachment = (file: any) => {
        let tmpAttachments = [...chapter.attachments]
        const fileIndex = tmpAttachments.findIndex((i: any) => i.name === file.name)
        tmpAttachments.splice(fileIndex, 1)
        onSaveChapter({
            ...chapter,
            attachments: tmpAttachments,
        })
    }

    const onSave = () => {
        onSaveChapter({
            ...chapter,
            text: text,
            title: title,
            index: index,
            isDone: true,
            isEdit: false,
        })
    }

    const ctaTemplate = (
        <Fragment>
            <div className="link-mini" onClick={onReduceChapter}>
                {intl.formatMessage({
                    id: 'modals.new.activity.section.delete',
                    defaultMessage: 'Delete',
                })}
            </div>
            <LuxButton
                onClick={onSave}
                variant="outlined"
                disabled={disabledSave}
                text={intl.formatMessage({
                    id: 'modals.new.activity.section.action.chapter.save',
                    defaultMessage: 'Save Chapter',
                })}
            />
        </Fragment>
    )

    return (
        <SectionItemContainer ctaTemplate={ctaTemplate}>
            <SectionItem>
                <div className={`${componentClass}__item-title`} onClick={() => onReduceChapter()}>
                    <span className={`${componentClass}__item-title-reduce`}>-</span>
                    <span className="link-mini">
                        {intl.formatMessage(
                            {
                                id: 'modals.new.activity.section.action.chapter.title',
                                defaultMessage: 'Chapter',
                            },
                            { index: index + 1 }
                        )}
                    </span>
                </div>
            </SectionItem>
            <div className={`${componentClass}__field-container`}>
                <LuxTextInput
                    icon="pencil"
                    value={title}
                    mandatory={true}
                    label={intl.formatMessage({
                        id: `modals.new_resource.label.chapter.title`,
                        defaultMessage: `Chapter title`,
                    })}
                    iconPosition="right"
                    placeholder={intl.formatMessage({
                        id: 'modals.new_resource.placeholder.type_here',
                        defaultMessage: 'Type here...',
                    })}
                    onChangeCallback={(e: any) => setTitle(e)}
                />
            </div>
            <div className={`${componentClass}__field-container`}>
                <LuxRichInputText
                    value={text}
                    mandatory={true}
                    onChangeCallback={(value) => {
                        setText(value)
                    }}
                    placeholder={intl.formatMessage({
                        id: 'modals.new.activity.section.action.question.text.placeholder',
                        defaultMessage: 'Type here',
                    })}
                    config={{
                        events: {
                            initialized() {
                                const editor = this
                                if (disabled) editor.edit.off()
                            },
                        },
                    }}
                    fileUploadUrl={ResourcesService.FROALA_UPLOAD_URL}
                />
            </div>
            <div className={`${componentClass}__field-container`}>
                <AddAttachment
                    showRemoveIcon
                    disabled={disabled}
                    customEndpoint="resource"
                    showSplitFile={false}
                    id={`chapter-${Math.random() * 100}`}
                    onUpload={(file) => onUploadAttachment(file)}
                    onRemove={(file) => onRemoveAttachment(file)}
                    form={{ attachmentList: { value: chapter.attachments } }}
                />
            </div>
        </SectionItemContainer>
    )
}

export default ArticleChapter
